import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useAuth0 } from "@auth0/auth0-react";
import { setIsLogout } from "redux/actions/portal/settingsActionCreator";
import useSocketUserDisconnect from "hooks/useSocketUserDisconnect";
import { addErrorLog } from "../Logger/logger";
import { userLogout, userLogoutSuccessReset, setSuspendedUserFlag } from "redux/actions/portal/authActionCreator";
import { CROSS_TAB_LOGOUT_KEY } from "helpers/authErrors";

const useLogout = () => {
   const { themeMode, isSystemTheme } = useSelector((store) => store?.portal?.settings);
   const { userLogoutSuccess, isSuspendedUser } = useSelector((store) => store?.portal?.auth);
   const { userDisconnect } = useSocketUserDisconnect();
   const dispatch = useDispatch();
   const { user, logout } = useAuth0();

   const portalLogout = (isSuspended) => {
      try {
         dispatch(setSuspendedUserFlag(!!isSuspended));
         dispatch(userLogout(user?.stripeId, user?.sub, isSuspended));
      } catch (error) {
         addErrorLog("Logout", error, user?.stripeId);
      }
   };

   useEffect(() => {
      if (userLogoutSuccess) {
         const allowToUsePortalUnderMaintenance = localStorage.getItem("allowToUsePortalUnderMaintenance");
         // Signal all other open tabs to log out before we clear localStorage
         localStorage.setItem(CROSS_TAB_LOGOUT_KEY, Date.now().toString());
         const usersRecentNodes = localStorage.getItem("usersRecentNodes");

         localStorage.clear();
         localStorage.setItem("allowToUsePortalUnderMaintenance", allowToUsePortalUnderMaintenance);
         if (usersRecentNodes) {
            localStorage.setItem("usersRecentNodes", usersRecentNodes);
         }
         localStorage.setItem(`themeMode_${user?.stripeId}`, themeMode);
         localStorage.setItem(`isSystemTheme_${user?.stripeId}`, isSystemTheme);
         localStorage.setItem(`tabCount`, 0);

         if (isSuspendedUser) {
            localStorage.setItem(`userSuspendedMessage`, "Your account have been suspended, Please contact your administrator for help");
            localStorage.setItem(`isUserSuspended`, true);
         }
         dispatch(userLogoutSuccessReset());
         dispatch(setIsLogout(true));
         userDisconnect();
         logout({
            logoutParams: {
               returnTo: window.location.protocol + "//" + window.location.host + "/authentication/sign-in"
            }
         });
      }
   }, [userLogoutSuccess]);

   return { portalLogout };
};

export default useLogout;
